import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from './Modal.index';

export default class OrphanedCategoryModal extends Component {

    static propTypes = {
        isModalLoading:  PropTypes.bool,
        primaryI18n:     PropTypes.string,
        secondaryI18n:   PropTypes.string,
        primaryAction:   PropTypes.func.isRequired,
        secondaryAction: PropTypes.func.isRequired
    };

    static defaultProps = {
        isModalLoading: false,
        primaryI18n:    "General_CoreFunctionality_UIText_general.delete",
        secondaryI18n:  "General_CoreFunctionality_UIText_general.cancel"
    };

    constructor(props) {
        super(props);

        this.state = {
            primaryWasClicked: false
        };

        this.handlePrimaryButtonClick = this.handlePrimaryButtonClick.bind(this);
    }

    handlePrimaryButtonClick() {
        this.setState({primaryWasClicked: true});
        this.props.primaryAction();
    }

    render() {

        return (
            <div id={this.props.modalName} className='category-entity-modal'>

                <Modal closeButtonHandler={this.props.isModalLoading || this.state.primaryWasClicked
                    ? null : this.props.secondaryAction}
                       buttons={
                           [
                               {
                                   text:       <FormattedMessage
                                                   id={this.props.primaryI18n} />,
                                   primary:    true,
                                   isDisabled: this.props.isModalLoading || this.state.primaryWasClicked,
                                   click:      this.handlePrimaryButtonClick
                               },
                               {
                                   text:       <FormattedMessage
                                                   id={this.props.secondaryI18n} />,
                                   isDisabled: this.props.isModalLoading || this.state.primaryWasClicked,
                                   click:      this.props.secondaryAction,
                                   tabIndex:   1
                               }
                           ]
                       }>

                    <div>
                        <h2 className="modal-header">{this.props.title}</h2>
                        <div className="divider"></div>
                        <div className='modal-body-container'>
                            {
                                this.props.isModalLoading || this.state.primaryWasClicked ?
                                    <div className='inline-spinner'></div>
                                    :
                                    null
                            }
                            {this.props.children}
                        </div>
                    </div>

                </Modal>

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Modal/OrphanedCategoryModal.jsx